import { render, staticRenderFns } from "./FinanceForm.vue?vue&type=template&id=2c4c9991&"
import script from "./FinanceForm.vue?vue&type=script&lang=ts&"
export * from "./FinanceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports